import type { VerificationState } from './verifications.schema';
import { useVerificationsQuery } from './verifications.queries';

const ACTIONABLE_STATES: VerificationState[] = [
  'not-submitted',
  'incomplete',
  'resubmission-requested',
];

export const useHasActionableVerification = (): boolean => {
  const { data } = useVerificationsQuery();
  const items = data?.items;

  if (!items) {
    return false;
  }

  return items.some(v => ACTIONABLE_STATES.includes(v.state));
};
